import NotificationAdminPanel from "@modules/notification/notifi_admin_op_dlg.tsx";
import React from "react";
import logo from "@assets/images/LOGO_MPS.png";
import { logoutKeycloak } from "@core/keycloak/keycloak-config.ts";
import { Button } from "primereact/button";

interface MobileHeaderProps {
  onMenuToggle: () => void;
  isMenuOpen: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onMenuToggle,
  isMenuOpen,
}) => {
  const handleLogout = () => {
    logoutKeycloak();
  };

  return (
    <header
      className="fixed rounded-b-lg top-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-b border-slate-200/50 shadow-2xl z-30 lg:hidden 
        transition-transform duration-300"
    >
      <div className="flex items-center justify-between px-6 py-4">
        <button
          onClick={onMenuToggle}
          className="relative p-3 flex items-center justify-center rounded-full transition-all duration-200"
          aria-label="Toggle menu"
        >
          <i
            className={`pi pi-bars text-black ${
              isMenuOpen ? "rotate-180 scale-110" : ""
            }`}
          />
        </button>

        <div className="flex items-center justify-center">
          <img src={logo} alt="Logo" className="w-20 h-auto" />
        </div>

        <div className="flex items-center justify-center">
          <button className="p-2 rounded-full">
            <NotificationAdminPanel />
          </button>

          <Button onClick={handleLogout} icon="pi pi-sign-out text-[#6C757D]" />
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
